import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import SolarRenewable from "../views/SolarRenewable";
import LinesSubstations from "../views/LinesSubstations";
import ElectricalInstallations from "../views/ElectricalInstallations";
import GeneratorServicing from "../views/GeneratorServicing";
import MotorRewinding from "../views/MotorRewinding";
import Pumps from "../views/Pumps";
import SecurityAC from "../views/SecurityAC";
import SupplyAccessories from "../views/SupplyAccessories";
import EnergyManagement from "../views/EnergyManagement";

// Placeholder components for newly added services
import HMIS from "../views/HMIS";
import BiometricAccess from "../views/BiometricAccess";
import ERPSystem from "../views/ERPSystem";
import SMIS from "../views/SMIS";
import BulkSMS from "../views/BulkSMS";
import WebHosting from "../views/WebHosting";
import ITConsulting from "../views/ITConsulting";

const serviceViewBySubItem = {
  "ict-consulting-strategy": LinesSubstations,
  "systems-integration": ElectricalInstallations,
  "network-infrastructure-solutions": SolarRenewable,
  "software-application-development": GeneratorServicing,
  "it-support-maintenance": MotorRewinding,
  "digital-transformation-solutions": Pumps,
  "secure-workplace-continuity-support": SecurityAC,
  "technology-procurement-deployment": SupplyAccessories,
  "data-analytics-performance-insights": EnergyManagement,
  
  // Newly added IT services
  "hmis": HMIS,
  "biometric-access-control": BiometricAccess,
  "erp-system": ERPSystem,
  "smis": SMIS,
  "bulk-sms-event-management": BulkSMS,
  "web-hosting": WebHosting,
  "it-consulting-services": ITConsulting,
};

const legacyServiceSubItemAliases = {
  "lines-substations": "ict-consulting-strategy",
  "electrical-installations": "systems-integration",
  "solar-renewable": "network-infrastructure-solutions",
  "generator-servicing": "software-application-development",
  "motor-rewinding": "it-support-maintenance",
  "pumps": "digital-transformation-solutions",
  "security-ac": "secure-workplace-continuity-support",
  "supply-accessories": "technology-procurement-deployment",
  "energy-management": "data-analytics-performance-insights",

  // Legacy aliases for new services (if any)
  "hospital-management-system": "hmis",
  "biometric-access": "biometric-access-control",
  "enterprise-resource-planning": "erp-system",
  "school-management-system": "smis",
  "bulk-sms-management": "bulk-sms-event-management",
  "hosting-services": "web-hosting",
  "it-consulting": "it-consulting-services",
};

export default function Services(props) {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    const { navSubItem, navExtraItem, navMoreItem } = appContext;

    if (!navSubItem && !navExtraItem && !navMoreItem) {
      return <ServicesLanding />;
    }

    if (navExtraItem || navMoreItem) {
      return null;
    }

    const resolvedSubItem = legacyServiceSubItemAliases[navSubItem] || navSubItem;
    const ServiceView = serviceViewBySubItem[resolvedSubItem];

    return ServiceView ? <ServiceView /> : null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}